import { NoteDetail, NoteListItem } from "creso-core/types";

export const transformNoteDetailToListItem = (
  note: NoteDetail
): NoteListItem => {
  return {
    client_name: note.client_name,
    client_id: note.client_id || undefined,
    id: note.id,
    raw_text: note.raw_text,
    summary: note.summary,
    task_count: note.tasks?.length || 0,
    title: note.title,
    created_at: note.created_at,
  };
};

export const transformNoteListToNoteDetailItem = (
  note: NoteListItem
): NoteDetail => {
  return {
    client_name: note.client_name ?? "",
    client_id: note.client_id || null,
    id: note.id,
    raw_text: note.raw_text,
    summary: note.summary,
    tasks: [],
    title: note.title,
    created_at: note.created_at,
  };
};
